import { BaseSpace } from 'app/components/common/BaseSpace'
import styled from 'styled-components'

export const SpaceWrapper = styled(BaseSpace)`
  width: 100%;
`